<template>
  <div>
    <page-header title="About" class="page-banner"></page-header>

    <section class="text-center mt-5">
      <div class="container">
        <h2 class="title mb-4">Our Mission</h2>
        <div class="row mt-4">
          <div class="col col-md-6 offset-md-3">
            <p class="lead">
              CTO Circle is a global network of senior business leaders who help
              each other succeed. Our goal is to be the ultimate
              <a
                href="https://techcrunch.com/2016/04/26/weak-ties-matter/"
                target="_blank"
                >weak tie</a
              >, creating opportunity by efficiently connecting leaders with the
              people, ideas, capital, and expertise they need to succeed.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="values text-center mt-5">
      <div class="container">
        <h2 class="title mb-4">Our Values</h2>
        <div class="row mt-4">
          <div
            class="col-lg-4 mb-4"
            v-for="(value, index) in values"
            :key="index"
          >
            <div
              class="d-md-flex text-md-left text-lg-center align-items-md-center d-lg-block"
            >
              <div class="image">
                <img :src="value.icon" />
              </div>
              <div class="mt-3">
                <h5>{{ value.title }}</h5>
                <p>{{ value.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="our-team">
      <div>
        <h2 class="title">Our Team</h2>
        <team-slider :team="team"></team-slider>
      </div>
    </section>

    <!-- HIDDEN TEMPORARILY. PLEASE DO NOT REMOVE.
         <section class="advisory">
            <div class="container">
                <h2 class="title">Our Advisors</h2>
                <div class="row">
                    <a class="col-md-6 col-lg-4 mb-4" v-for="(member, index) in advisors" :key="index" :href="member.linkedin" target="_blank">
                        <member-card
                            :key="index"
                            :member="member"
                        ></member-card>
                    </a>
                </div>
            </div>
        </section> -->

    <section class="employment">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-5 order-md-2">
            <h2>Grow with us</h2>
            <p>
              We welcome applications from talented developers, product/project
              managers, and community builders across the world.
            </p>
          </div>
          <div class="col-md-7 order-md-1">
            <div class="image-wrapper">
              <a
                href="https://careers.csuitecircle.com/"
                class="btn btn-primary"
                target="_blank"
                >See opportunities</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="get-in-touch">
            <div class="container">
                <h2 class="title">Get In Touch</h2>
                <p>We'd love to chat. Use the form below, or email us at <a href="mailto:hello@csuitecircle.com">hello@csuitecircle.com</a>.</p>
                <contact-form></contact-form>
            </div>
        </section> -->
  </div>
</template>

<script>
import PageHeader from '@/components/global/PageHeader';
import MemberCard from '@/components/global/MemberCard';
import BasicGoogleMap from '@/components/global/BasicGoogleMap';
// import ContactForm from "@/components/about/ContactForm";
import TeamSlider from '@/components/about/TeamSlider';

export default {
  components: {
    PageHeader,
    MemberCard,
    BasicGoogleMap,
    // ContactForm,
    TeamSlider
  },
  data() {
    return {
      marker: {
        latitude: '1.309829',
        longitude: '103.856403'
      },
      values: [
        {
          icon: require('@/assets/img/Icon-Reciprocity.png'),
          title: 'Reciprocity',
          description:
            'Opportunity is a positive-sum game. As a community, we share our time, connections, and expertise with others to help them succeed.'
        },
        {
          icon: require('@/assets/img/Icon-Transparence.png'),
          title: 'Transparency',
          description:
            'No person, organization, or system is perfect. Transparency at every level leads to better outcomes for everyone.'
        },
        {
          icon: require('@/assets/img/Icon-Generosity.png'),
          title: 'Generosity',
          description:
            'As members of the <<one percent>>, we recognise our unique privilege and embrace our responsibility to society as a whole.'
        }
      ],
      team: [
        {
          name: 'Janakan Arulkumarasan',
          title: 'CEO',
          picture:
            'https://csg-cdn.s3.amazonaws.com/02776f1b-907f-44ef-bad2-ec45e37b4f0f',
          linkedin: 'https://www.linkedin.com/in/arulkumarasan',
          management: true
        },
        {
          name: 'Jeyanti Yorke',
          title: 'CMO',
          picture:
            'https://csg-cdn.s3.amazonaws.com/0e7b0237-899a-43d5-8fa3-12650bba4df9',
          linkedin: 'https://www.linkedin.com/in/jeyanti-yorke-58901114',
          management: true
        },
        {
          name: 'David Del Favero',
          title: 'CTO',
          picture:
            'https://csg-cdn.s3.amazonaws.com/a328fb28-ebba-4e2c-8a83-6e8237cf133c',
          linkedin: 'https://www.linkedin.com/in/david-del-favero-5b942132',
          management: true
        },
        {
          name: 'Rajiv Khatri',
          title: 'COO',
          picture:
            'https://csg-cdn.s3.amazonaws.com/39aea94f-e40f-47c0-960c-7ec7004495a3',
          linkedin: 'https://www.linkedin.com/in/rajivkhatri1/',
          management: true
        },
        {
          name: 'Aida Opîrlesc',
          title: 'Developer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/fd02776d-9562-490d-a42a-36d5c62d1a95',
          linkedin: 'https://www.linkedin.com/in/aida-op%C3%AErlesc-9317a0115'
        },
        {
          name: 'Arina Kurbatova',
          title: 'Designer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/a5b30e23-ef4c-4228-b17b-4a523117b14e',
          linkedin: 'https://www.linkedin.com/in/arina-kurbatova-91279769'
        },
        {
          name: 'Kanishka Joshi',
          title: 'Developer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/0e598eb4-e5b9-48c8-9d83-5ee889d64909',
          linkedin: 'https://www.linkedin.com/in/kanishka-joshi-1abb63a1'
        },
        {
          name: 'Priyanka Solanki',
          title: 'Developer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/259a9a2a-ef05-48c5-a230-6b0e2dd1099d',
          linkedin: 'https://www.linkedin.com/in/priyanka-solanki/'
        },
        {
          name: 'Aastha Panta',
          title: 'Developer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/7eb47f5b-30a5-4155-b16d-7361e53e9020',
          linkedin: 'https://www.linkedin.com/in/aastha-panta-a7b599128/'
        },
        {
          name: 'Madhurjya Bora',
          title: 'Developer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/7aef95b5-8769-48a2-91b0-de39c86ae264',
          linkedin: 'https://www.linkedin.com/in/madhurjya-bora-51a35a163/'
        },
        {
          name: 'Beverly Sanchez',
          title: 'Connector',
          picture:
            'https://csg-cdn.s3.amazonaws.com/d0c9f430-a429-414d-8b67-e5365694a8f5',
          linkedin: 'https://www.linkedin.com/in/beverly-sanchez-b431461b8/'
        },
        {
          name: 'Jonalyne Tingchuy',
          title: 'Connector',
          picture:
            'https://csg-cdn.s3.amazonaws.com/3b9b2f42-ceea-4a57-9e38-82262561034d',
          linkedin: 'https://www.linkedin.com/in/jonalyne-tingchuy-88b0301b8/'
        },
        {
          name: 'Vidya Shetty',
          title: 'Project Manager',
          picture:
            'https://csg-cdn.s3.amazonaws.com/610ece47-4d7d-4a62-b49c-ba20dcc020c4',
          linkedin: 'https://www.linkedin.com/in/shrividya-shetty-k-34477556/'
        },
        {
          name: 'Asfaque Ali Ansari',
          title: 'Designer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/92092035-f491-44db-bc88-f62d6a961285',
          linkedin: 'https://www.linkedin.com/in/asfaquealiansari/'
        },
        {
          name: 'Shruthi Tom',
          title: 'Designer',
          picture:
            'https://csg-cdn.s3.amazonaws.com/adaa987c-8bb6-4b4e-a51a-9c618626337e',
          linkedin: 'https://www.linkedin.com/in/shruthielsa/'
        }
      ],
      advisors: [
        {
          name: 'Christopher Veit',
          title: 'CEO at VEIT Group',
          picture:
            'https://csg-cdn.s3.amazonaws.com/e1390576-a5ca-4199-be19-ad466804d90e',
          linkedin:
            'https://www.linkedin.com/in/christopher-manuel-veit-57772476'
        },
        {
          name: 'So-Young Kang',
          title: 'CEO at Gnowbe',
          picture:
            'https://csg-cdn.s3.amazonaws.com/feea01d9-78a8-4d9c-bff9-9b2cdc5b6276',
          linkedin: 'https://www.linkedin.com/in/soykang'
        },
        {
          name: 'Melissa Kwee',
          title: 'CEO at NVPC',
          picture:
            'https://csg-cdn.s3.amazonaws.com/2141b52f-d280-46f3-922d-609fc84584cb',
          linkedin: 'https://www.linkedin.com/in/melissa-aratani-kwee-2562953'
        },
        {
          name: 'Richard Melheim',
          title: 'CEO at RICH Learning Global',
          picture:
            'https://csg-cdn.s3.amazonaws.com/c0107044-29fe-4a9a-8e08-f4d385320759',
          linkedin: 'https://www.linkedin.com/in/rich-melheim-9050013'
        },
        {
          name: 'Arun Makhija',
          title: 'CEO at foodpanda',
          picture:
            'https://csg-cdn.s3.amazonaws.com/0d67d858-3fed-4ba2-ac98-7b41afd5d8a0',
          linkedin: 'https://www.linkedin.com/in/arun-makhija-b4417925'
        },
        {
          name: 'James Mischel Jr.',
          title: 'CEO, Electric Mirror',
          picture:
            'https://csg-cdn.s3.amazonaws.com/9b8cc295-3e7e-4664-96f9-e142f981d367',
          linkedin: 'https://www.linkedin.com/in/jimmischel'
        },
        {
          name: 'Shaun Sinniah',
          title: 'COO, Guy Carpenter',
          picture:
            'https://csg-cdn.s3.amazonaws.com/20d18bf8-7c4d-41dd-abb5-3e066820d157',
          linkedin: 'https://www.linkedin.com/in/shaun-sinniah-44b6371b'
        },
        {
          name: 'Sam Kurien',
          title: 'Global CIO at The Alliance',
          picture:
            'https://csg-cdn.s3.amazonaws.com/fe255958-55e6-4d2c-a9d0-9ec16419e941',
          linkedin: 'https://www.linkedin.com/in/dr-sam-kurien-304a853/'
        },
        {
          name: 'Ronald Raj S J',
          title: 'Founder & CEO, ThoughtCapital',
          picture:
            'https://csg-cdn.s3.amazonaws.com/a4714bbb-5bff-47a5-a2f8-af570b7602d1',
          linkedin: 'https://www.linkedin.com/in/ronaldraj/'
        },
        {
          name: 'Daniel Chua',
          title: 'CEO, Titus Group',
          picture:
            'https://csg-cdn.s3.amazonaws.com/9342b7c3-1e94-43c3-8d87-fb904ca13e98',
          linkedin: 'https://titus.com.sg/'
        },
        {
          name: 'Robert Baehr',
          title: 'President at MovieGuide',
          picture:
            'https://csg-cdn.s3.amazonaws.com/711710f5-941d-49c3-9a72-35269849f823',
          linkedin: 'https://www.linkedin.com/in/robert-baehr-3792b76'
        },
        {
          name: 'David Peters',
          title: 'CEO at Cephas International',
          picture:
            'https://csg-cdn.s3.amazonaws.com/64264339-fee8-4ab2-b90d-9a60492ef0ca',
          linkedin: 'https://www.linkedin.com/in/david-mark-peters-7aa9098a'
        },
        {
          name: 'James Low',
          title: 'CEO at Intentional Apps',
          picture:
            'https://csg-cdn.s3.amazonaws.com/ca7fc20a-9a78-4d50-8d0c-336ab324df6e',
          linkedin: 'https://www.linkedin.com/in/jamesdlow'
        },
        {
          name: 'Kurian Babykutty',
          title: 'CEO at 40 Parables',
          picture:
            'https://csg-cdn.s3.amazonaws.com/995f6661-3b7b-4092-8efe-b95e191d379f',
          linkedin: 'https://www.linkedin.com/in/kurianbk'
        },
        {
          name: 'Ian Fong',
          picture:
            'https://csg-cdn.s3.amazonaws.com/f2fde4a3-aba6-4a46-a54c-94a6e8f2e454',
          title: 'CEO, Founder at CUFFS',
          linkedin: 'https://www.linkedin.com/in/ianfong'
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.page-banner .text {
  color: #ffffff;
  display: block;
}
.page-banner {
  background-color: $primary;
  background-image: url('~@/assets/img/About-Decor-Head-Mobile@2x.png');
  background-size: contain;
  background-position: bottom right;
  background-repeat: no-repeat;

  @include media-breakpoint-up(lg) {
    background-image: url('~@/assets/img/About-Decor-Head@2x.png');
    background-size: contain;
  }

  /deep/ .banner-content {
    max-width: 600px;
    h1 {
      margin-bottom: 30px;
      margin-top: 16px;
    }
  }
}
</style>
<style lang="scss" scoped>
h2.title {
  font-size: 39px;
  font-weight: 900;
  text-align: center;
  margin-bottom: 30px;
}

img {
  max-width: 100%;
}

.mission {
}

.values {
  padding: 40px 0 20px;
  background-color: white;

  @include media-breakpoint-up(lg) {
    padding: 60px 0 30px;
  }

  p {
    font-size: 15px;
    color: #505b64;
    line-height: 24px;
  }

  h5 {
    font-weight: 700;
  }

  img {
    @include media-breakpoint-up(md) {
      max-width: 245px;
      margin-right: 40px;
    }

    @include media-breakpoint-up(lg) {
      max-width: 100%;
      margin-right: 0;
    }
  }
}

.our-team {
  background-color: $secondary;
  color: #ffffff;
  text-align: center;
  padding: 70px 0 40px;
  @include media-breakpoint-up(md) {
    padding: 90px 0 150px;
  }

  .title {
    margin-bottom: 65px;
  }
}

.advisory {
  padding: 60px 0;
  .title {
    margin-bottom: 70px;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  /deep/ .card {
    padding: 25px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    @include media-breakpoint-up(md) {
      flex-direction: row;
      text-align: left;
      padding: 40px 30px;
    }

    &:hover {
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.06);
    }

    .picture {
      margin-bottom: 20px;
      min-width: 90px;
      min-height: 90px;
      padding-bottom: 70px;
      @include media-breakpoint-up(md) {
        margin: 0 15px 0 0;
      }
    }
  }
}

.employment {
  padding: 70px 0 60px;
  text-align: center;
  @include media-breakpoint-up(md) {
    text-align: left;
  }
  .image-wrapper {
    background-image: url('~@/assets/img/Photos@2x.png');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    padding: 160px 0;
    text-align: center;
  }

  .btn-primary {
    padding: 7px 30px;
    font-size: 18px;
    font-weight: 400;
  }

  h2 {
    font-size: 28px;
    font-weight: 900;
    line-height: 35px;
  }

  p {
    color: #505b64;
    font-size: 15px;
    line-height: 24px;
  }
}

.get-in-touch {
  background-color: #ffffff;
  position: relative;
  background-image: url('~@/assets/img/Decor-Head.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 47%;

  @include media-breakpoint-up(md) {
    background-size: contain;
    background-position: bottom right;
  }

  .container {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  h2 {
    margin-bottom: 20px;
  }

  p {
    max-width: 550px;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 40px;
    color: #505b64;
  }
}

.contact-details {
  background-color: #010327;
  color: #ffffff;
  padding: 60px 0 50px;
  text-align: center;
  @include media-breakpoint-up(md) {
    text-align: left;
  }

  h2 {
    @include media-breakpoint-up(md) {
      text-align: left;
    }
  }

  h6 {
    font-size: 18px;
    font-weight: 700;
  }

  .headquaters {
    @include make-col-ready();
    @include media-breakpoint-up(md) {
      @include make-col(12);
    }
    @include media-breakpoint-up(lg) {
      @include make-col(6.7);
    }
    a {
      color: $grey;
      font-size: 16px;
    }
  }

  .address {
    font-size: 16px;
    line-height: 24px;

    svg {
      fill: $grey;
      margin-left: -21px;
      margin-right: 6px;
    }
  }

  .google-map {
    margin: 30px auto;
    max-width: 400px;
    @include make-col-ready();
    @include media-breakpoint-up(md) {
      @include make-col(12);
      margin-top: 50px;
    }
    @include media-breakpoint-up(lg) {
      @include make-col(5.3);
      margin: 0;
      padding: 0 30px;
    }
  }

  /deep/ .map {
    height: 207px;
    @include media-breakpoint-up(md) {
      height: 280px;
    }
  }
}
.lead a {
  font-size: 1.25rem;
  font-weight: 300;
}
@media (max-width: 767px) {
  h2.title {
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  .our-team .title {
    margin-bottom: 35px;
  }
  .employment h2 {
    margin-bottom: 20px;
  }
  .lead a {
    font-size: 1rem;
  }
}
</style>
